import type { ReactNode } from "react";

function Icon({ children, size = 22 }: { children: ReactNode; size?: number }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

export const PlayersIcon = (p: { size?: number }) => (
  <Icon {...p}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3 19.5c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" />
    <path d="M16 5.2a3 3 0 0 1 0 5.6M18 14.4c1.9.7 3 2.4 3 5.1" />
  </Icon>
);

export const AssetsIcon = (p: { size?: number }) => (
  <Icon {...p}>
    <path d="M3.5 11 12 4l8.5 7" />
    <path d="M5.5 9.7V20h13V9.7" />
    <path d="M10 20v-5.5h4V20" />
  </Icon>
);

export const TradeIcon = (p: { size?: number }) => (
  <Icon {...p}>
    <path d="M4 8h14l-3.5-3.5M20 16H6l3.5 3.5" />
  </Icon>
);

export const ChatIcon = (p: { size?: number }) => (
  <Icon {...p}>
    <path d="M4 5.5h16v10.5H10l-4.5 3.5V16H4z" />
    <path d="M8 9.5h8M8 12.5h5" />
  </Icon>
);

export const FlagIcon = (p: { size?: number }) => (
  <Icon {...p}>
    <path d="M5.5 21V4M5.5 5h11l-2 3.5 2 3.5h-11" />
  </Icon>
);

export const LinkIcon = (p: { size?: number }) => (
  <Icon {...p}>
    <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
    <path d="M14 10a4 4 0 0 0-5.7 0l-3 3A4 4 0 0 0 11 18.7l1-1" />
  </Icon>
);

export const ClockIcon = (p: { size?: number }) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 2" />
  </Icon>
);

export const JailIcon = (p: { size?: number }) => (
  <Icon {...p}>
    <rect x="4.5" y="4.5" width="15" height="15" rx="1.5" />
    <path d="M9 4.5v15M12 4.5v15M15 4.5v15" />
  </Icon>
);

export const EyeIcon = (p: { size?: number }) => (
  <Icon {...p}>
    <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
    <circle cx="12" cy="12" r="3" />
  </Icon>
);

export const KeyboardIcon = (p: { size?: number }) => (
  <Icon {...p}>
    <rect x="2.5" y="6" width="19" height="12" rx="2" />
    <path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M6 14h.01M18 14h.01M9 14h6" />
  </Icon>
);
